module.exports = __webpack_public_path__ + "img/U2.f1aecf72.png";